import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

@Injectable()
export class WatchlistIotActions {
    static BID_INFO_UPDATED = '[WL] Bid Info Updated';
    static VEHICLE_UPDATED = '[WL] Vehicle Info Updated';
    static VEHICLE_REMOVED = '[WL] Vehicle Removed From Event';

    bidInfoUpdated(payload): Action {
        return {
            type   : WatchlistIotActions.BID_INFO_UPDATED,
            payload: payload
        };
    }

    vehicleUpdated(payload): Action {
        return {
            type   : WatchlistIotActions.VEHICLE_UPDATED,
            payload: payload
        };
    }

    vehicleRemoved(payload): Action {
        return {
            type   : WatchlistIotActions.VEHICLE_REMOVED,
            payload: payload
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/store/actions/WatchlistIotActions.ts